import { Button, Container, Row, Col, Card, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import icValidationError from '../../assets/img/ic-danger.svg';
import openPublicPdf from '../../utils/openPublicPdf';

const RegisterTalentStep1 = ({ email, errors, onEmailChange, onEmailBlur, agree, setAgree, onNext }) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ query: '(max-width: 767.98px)' });

    return (
        <main className="main-content flex-grow-1 ms-0">
            <Container>
                <Row>
                    {/* Main Content */}
                    <Col xl={4} className="offset-xl-4 pt-5">
                        <Card>
                            <Card.Body>
                                <Form onSubmit={onNext}>
                                    <div className={isMobile ? 'mb-4' : 'mb-5'}>
                                        <h2 className="mb-3">New account</h2>
                                        <p>Sign up with your email address</p>
                                    </div>

                                    <Form.Group className="validated" controlId="email">
                                        <Form.Label>Email address <span>*</span></Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={email}
                                            onChange={onEmailChange}
                                            onBlur={onEmailBlur}
                                            isInvalid={!!errors?.email}
                                            required
                                        />
                                        {errors?.email && (
                                            <div className="custom-error-icon-wrapper">
                                                <img
                                                    src={icValidationError}
                                                    alt={errors.email}
                                                    className="custom-error-icon"
                                                />
                                                <div className="custom-tooltip">
                                                    {errors.email}
                                                </div>
                                            </div>
                                        )}
                                    </Form.Group>

                                    {/* Terms of Use */}
                                    <div className="my-4">
                                        <label>
                                            <input
                                                className="me-2"
                                                type="checkbox"
                                                checked={agree}
                                                onChange={(e) => setAgree(e.target.checked)}
                                            />
                                            I agree to the&nbsp;
                                            <a
                                                href="/Abroadify-Terms-of-Use.pdf"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="mb-5 text-primary"
                                                onClick={(e) => openPublicPdf(e, '/Abroadify-Terms-of-Use.pdf')}
                                            >
                                                <strong>Terms of Use</strong>
                                            </a> and&nbsp;
                                            <a
                                                href="/Abroadify-Privacy-Notice.pdf"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="mb-5 text-primary"
                                                onClick={(e) => openPublicPdf(e, '/Abroadify-Privacy-Notice.pdf')}
                                            >
                                                <strong>Privacy Policy</strong>
                                            </a>
                                        </label>
                                    </div>

                                    <Button
                                        type="submit"
                                        variant="primary w-100 justify-content-center"
                                        className={isMobile ? 'mb-2' : undefined}
                                        disabled={!agree}
                                    >
                                        Continue
                                    </Button>

                                    {!isMobile && (
                                        <Row className="mt-3">
                                            <Col xs={12} className="text-center">
                                                <Button
                                                    type="button"
                                                    variant="outline-secondary w-100 justify-content-center"
                                                    onClick={() => navigate('/')}
                                                >
                                                    Back
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}
                                </Form>
                            </Card.Body>
                        </Card>

                        <Row className="buttons-row">
                            <Col xs={12}>
                                <p className="text-center">
                                    Already have an account? <a href="/">Login</a>
                                </p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </main>
    );
};

export default RegisterTalentStep1;
